<template>
    <div class="popup popup-full" id="search" tabindex="-1" aria-hidden="true">
        <header class="replboxHead">
            <h1>통합검색</h1>
            <div class="menu_side">
                <a onclick="backBtn('popup-full')" class="btn_detail_close" href="javascript:void(0)">
                  <span class="sr-only">검색창 닫기</span>
                  <i class="xi-close"></i>
                </a>
            </div>
        </header>

        <div class="search_page">
            <div class="search_box">
                <span>#</span>
                <input type="text" v-model="searchTerm" @input="autoSearch" @keydown.enter="searchKey" aria-label="검색어 입력">
                <a @click="searchKey(searchKey)" href="javascript:void(0)"><img src="@/assets/images/i_search_color.png" alt="검색"></a>
            </div>

            <dl class="search_page_box">
                <dt>
                    <span class="st">최근 검색어</span>
                    <a @click="allDelCookie" class="del" href="javascript:void(0)">전체삭제</a>
                </dt>
                <dd>
                    <ul class="search_page_reslt">
                        <li v-for="(key2) in recentSearchKey" :key="key2" @click="[searchTerm = key2, searchKey()]">
                            <a href="javascript:void(0)">
                              #{{key2}}
                              <a href="javascript:void(0)" @click.stop="delCookie('dq_cookie', key2)" class="del" style="padding: 0;">
                                <span class="sr-only">{{key2}} 검색어 삭제</span>
                                <i class="xi-close"></i>
                              </a>
                            </a>
                        </li>
                    </ul>

                </dd>
            </dl>


            <!-- <ul class="search_page_reslt">
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#신일<b>선풍기</b></a></li>
                <li><a href="#!">#무선<b>선풍기</b></a></li>
                <li><a href="#!">#탁상용<b>선풍기</b></a></li>
                <li><a href="#!">#르젠<b>선풍기</b></a></li>
                <li><a href="#!">#무선<b>선풍기</b></a></li>
                <li><a href="#!">#BLDC<b>선풍기</b></a></li>
                <li><a href="#!">#미니<b>선풍기</b></a></li>
                <li><a href="#!">#샤오미<b>선풍기</b></a></li>
                <li><a href="#!">#삼성<b>선풍기</b></a></li>
                <li><a href="#!">#넥밴드<b>선풍기</b></a></li>
                <li><a href="#!">#휴대용<b>선풍기</b></a></li>
                <li><a href="#!">#다이슨<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
                <li><a href="#!">#<b>선풍기</b></a></li>
            </ul> -->
            



            <!-- <div>
                <h1>자동완성</h1>
                <ul>
                    <li v-for="(auto) in searchInfoMobile.autoResultList" :key="auto.KEYWORDS" @click="[searchTerm = auto.KEYWORDS, searchKey()]">
                        <div>#{{auto.KEYWORDS}} </div>
                    </li>

                </ul>
            </div>
            


            <div>
                <h1>인기 검색어 {{searchInfoMobile.trendKeywordResultList_02_time}} 01시 05분 기준</h1>
                <ul>
                    <li v-for="(trend, i) in searchInfoMobile.trendKeywordResultList_02" :key="trend.KEYWORD" @click="[searchTerm = trend.KEYWORD, searchKey()]">
                        <div>{{i+1}}.#{{trend.KEYWORD}} </div>
                    </li>

                </ul>
            </div>


            <div>
                <h1>최근 검색어</h1>
                <ul>
                    <div @click="allDelCookie">전체삭제</div>
                    <li v-for="(key2, i) in recentSearchKey" :key="key2" @click="[searchTerm = key2, searchKey()]">
                        {{i+1}}.#{{key2}}<span @click.stop="delCookie('dq_cookie', key2)">X</span>
                    </li>

                </ul>
            </div>

            <div>
                <h1>자주 찾은 검색어</h1>
                <ul>
                    <li v-for="(trend, i) in searchInfoMobile.trendKeywordResultList_01" :key="trend.KEYWORD" @click="[searchTerm = trend.KEYWORD, searchKey()]">
                        <div>{{i+1}}.#{{trend.KEYWORD}} </div>
                    </li>

                </ul>
            </div> -->
        </div>
        <!-- alert -->
        <div class="popup search_01">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p v-html="alertMsg"></p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" onclick="modal('search_01')">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/service/EventBus'
// import {api} from '@/api/index.js'

export default {
    props: ['next'],
    data() {
        return {
            searchTerm: "",
            recentSearchKey: [],
            searchInfoMobile: {},
            alertMsg: ""
        }
    },
    methods: {
        async openSearch() {
            // await api.postAsync('/search/initMain.do')
            //    .then(data=> {
            //         this.searchInfoMobile = data.searchInfoMobile;
            //    });

            this.getRecentSearchKey();

            this.$nextTick(()=>{
                EventBus.$emit('open-modal','search');
            })

            window.setTimeout(function(){
              $('.popup-full.active').attr({'tabindex':0, 'aria-hidden':'false'}).focus();
            },100)
        },
        async searchKey() {

            if(this.searchTerm.trim() === "") {
                this.fnAlert("검색어를 입력해 주세요.");
                return;
            }

            this.addCookieKeyword();


            // let params = {searchTerm: this.searchTerm};
            // api.postAsync('/search/searchList.do', params)
            //     .then(data=>{
            //         console.log(data);
            //     })

            if(this.next === 'new') {
                let obj= {disp_ctg_nm:'내가 선택한 상품',
                          disp_ctg_no: '',
                          grp_cd_4: 'N',
                          searchTerm: this.searchTerm.trim()};
                this.$emit('selectEvent', obj);
            }
            else if(this.next === 'search') {
                this.$emit('searchGoods', this.searchTerm.trim());
                this.searchTerm = "";
            }

            this.$go(-1);
        },
        async autoSearch(event) { //자동완성
            this.searchTerm = event.target.value;

            // let params = {autoKeyword: this.searchTerm.trim()};

            // await api.postAsync('/search/autoSearch.do', params)
            //     .then(data=>{
            //         this.searchInfoMobile.autoResultList = data.autoResultList;
            //     })
        },
        // 최근검색어
        getRecentSearchKey() {
            this.recentSearchKey = [];
            let cookieValue = this.$cookies.get("dq_cookie");
            if(cookieValue != null) { // 쿠키값(최근 검색어)이 있는 경우
                let cookieValueArray = cookieValue.split("^");
                let cookieValueArrayLength = (cookieValueArray.length > 10) ? 10 : cookieValueArray.length;
                for(var i=0; i<cookieValueArrayLength; i++) {
                    this.recentSearchKey.push(cookieValueArray[i]);
                    //text += "<li><a href=\"javascript:doSearchMainByTerm('" + tempKeywordOrign + "')\">"+(i+1)+".#" + tempKeywordOrign + "</a><a href=\"javascript:delCookie('dq_cookie', '" + tempKeywordOrign + "')\" class=\"item-close\">닫기</a></li>";
                }
            }
        },
        
        delCookie(cookieName, keyword) {
            let tempCookieValue = this.$cookies.get(cookieName);
            let cookieValueArray = tempCookieValue.split("^");
            let cookieValue = "";
            if(cookieValueArray != "") {
                for(var i=0; i<cookieValueArray.length; i++) {
                    if(keyword != cookieValueArray[i]) { // 키워드가 같지 않으면 저장
                        if(cookieValue != "") {
                            cookieValue = cookieValue + "^";
                        }
                        // cookieValue = cookieValue + encodeURIComponent(cookieValueArray[i]);
                        cookieValue = cookieValue + cookieValueArray[i];
                    }
                    else {
                        this.recentSearchKey.splice(i,1)
                    }
                }
            }
            this.$cookies.set(cookieName, cookieValue); // 삭제 후 쿠키 저장
        },
        allDelCookie() {
            this.$cookies.set('dq_cookie', '');
            this.recentSearchKey = [];
        },
        // 검색어 쿠키에 추가하기(최근 검색어)
        addCookieKeyword() {
            let searchTerm = this.searchTerm;
            var cookieSaveYn = this.$cookies.get("dq_cookieSaveYn"); // 쿠키 저장 여부
            var resultCookieValue = "";
            if(cookieSaveYn != "N" && searchTerm != "") {
                var cookieValue = this.$cookies.get("dq_cookie"); // 기존 최근 검색어
                searchTerm = searchTerm.trim().replace("^", "");
                if(cookieValue != null) {
                    // resultCookieValue = encodeURIComponent(searchTerm); // 인코딩 해서 맨 앞에 저장
                    resultCookieValue = searchTerm; // 인코딩 해서 맨 앞에 저장
                    var cookieValueArray = cookieValue.split("^");

                    //20170406김기로
                    var cookieValueArrayLength = (cookieValueArray.length > 10) ? 10 : cookieValueArray.length;

                    for(var i=0; i<cookieValueArrayLength; i++) {
                        var cookie = cookieValueArray[i];
                        if(cookie != "") {
                            cookie = cookie.trim();
                            if(cookie != searchTerm) { // 이미 저장되어 있지 않은 경우
                                // resultCookieValue = resultCookieValue + "^" + encodeURIComponent(cookie);
                                resultCookieValue = resultCookieValue + "^" + cookie;
                            }
                        }
                    }
                } else {
                    // resultCookieValue = encodeURIComponent(searchTerm);
                    resultCookieValue = searchTerm;
                }

                // this.recentSearchKey.unshift(searchTerm);
            }
            this.$cookies.set("dq_cookie", resultCookieValue ,60*60*24*365);
        },
        fnAlert(msg) {
            this.alertMsg = msg;
            $('.search_01').addClass('active');
        }
    },
}
</script>